import React, { useEffect, useState } from 'react';

import { IconChevronDownSmall16, IconChevronUpSmall16 } from '../../Icons';
import * as s from './RealtorRatingTableTh.css';
import { ESortOrder } from '../../../types/sortOrder';

export enum EChevronType {
  Up = 'up',
  Down = 'down',
}

export interface IRealtorRatingTableTh {
  label: string;
  isSorted?: boolean;
  sortOrder?: ESortOrder;
  onClick?(sortOrder: ESortOrder): void;
}

/**
 * Заголовок колонки для таблицы рейтинга риелторов
 */
export const RealtorRatingTableTh = ({ label, isSorted, sortOrder, onClick }: IRealtorRatingTableTh) => {
  const [isHovered, setIsHovered] = useState(false);
  const [chevronType, setChevronType] = useState<EChevronType | null>(
    isSorted && sortOrder === ESortOrder.Asc
      ? EChevronType.Up
      : isSorted && sortOrder === ESortOrder.Desc
      ? EChevronType.Down
      : null,
  );

  useEffect(() => {
    /** Если не участвует в сортировке, то не показываем шеврон */
    if (!isSorted) {
      setChevronType(null);

      return;
    }

    /** Меняет up-шеврон на down-шеврон при наведении */
    if (isHovered && sortOrder === ESortOrder.Asc) {
      setChevronType(EChevronType.Down);

      return;
    }

    /** Меняет down-шеврон на up-шеврон при наведении */
    if (isHovered && sortOrder === ESortOrder.Desc) {
      setChevronType(EChevronType.Up);

      return;
    }

    /** Устанавливает up-шеврон */
    if (sortOrder === ESortOrder.Asc) {
      setChevronType(EChevronType.Up);

      return;
    }

    /** Устанавливает down-шеврон */
    if (sortOrder === ESortOrder.Desc) {
      setChevronType(EChevronType.Down);

      return;
    }
  }, [isHovered, isSorted, sortOrder]);

  return (
    <th
      className={`${s['wrapper']} ${onClick ? s['_clickable'] : ''}`}
      onClick={
        onClick ? () => onClick(chevronType === EChevronType.Down ? ESortOrder.Desc : ESortOrder.Asc) : undefined
      }
      onMouseEnter={onClick && (() => setIsHovered(isHovered => !isHovered))}
      onMouseLeave={onClick && (() => setIsHovered(isHovered => !isHovered))}
    >
      <span className={s['inner-wrapper']}>
        <span>{label}</span>
        {chevronType === EChevronType.Up && <IconChevronUpSmall16 />}
        {chevronType === EChevronType.Down && <IconChevronDownSmall16 />}
      </span>
    </th>
  );
};
